import { ProductColor, SizeProperty } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { Tr as PDFTr } from '../../components/pdf-export/Tr/Tr.js';
import { Tr as WebTr } from '../../components/table.js';
import { useIsPDF } from '../internal/useIsPDF.js';

type Props = PropsWithChildren<{
  backgroundColor?: ProductColor;
  borderTop?: string;
  height?: SizeProperty | string;
  width?: SizeProperty | string;
}>;

export function Tr(props: Props) {
  const { children, ...rest } = props;
  return useIsPDF() ? <PDFTr {...rest}>{children}</PDFTr> : <WebTr {...rest}>{children}</WebTr>;
}
